// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row-partners[data-v-c1522eda]{margin:0;justify-content:center;align-items:center;gap:0 16px}@media(min-width: 768px){.row-partners[data-v-c1522eda]{gap:0 calc((100% - 180px*4)/3)}}@media(min-width: 1200px){.row-partners[data-v-c1522eda]{gap:0 calc((100% - 180px*5)/4)}}.col-partner[data-v-c1522eda]{flex:0 0 180px;max-width:calc(50% - 8px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
